export const ID = 'fd8bc8b0-8d91-461d-a3e9-ca3a2d336e66';

export const NAME = 'Locations Near You';
